import {
  CheckCircle2, AlertTriangle, XCircle, HelpCircle,
} from "lucide-react";

/* ── Score ring ── */
export function ScoreRing({ score, size = 72 }) {
  const r = (size / 2) - 6;
  const c = 2 * Math.PI * r;
  const offset = c - ((score || 0) / 100) * c;
  const color = score >= 70 ? "#0d9488" : score >= 40 ? "#f59e0b" : "#e11d48";
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#f1f5f9" strokeWidth="5" />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth="5"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.8s ease" }} />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-base font-bold" style={{ fontFamily: 'Manrope, sans-serif', color: score != null ? color : '#cbd5e1' }}>
          {score ?? "--"}
        </span>
      </div>
    </div>
  );
}

/* ── Status config ── */
export const S = {
  pass:       { icon: CheckCircle2, c: "text-emerald-600", bg: "bg-emerald-50", b: "border-emerald-200" },
  warn:       { icon: AlertTriangle, c: "text-amber-600",  bg: "bg-amber-50",   b: "border-amber-200" },
  fail:       { icon: XCircle,       c: "text-rose-600",   bg: "bg-rose-50",     b: "border-rose-200" },
  found:      { icon: CheckCircle2, c: "text-emerald-600", bg: "bg-emerald-50", b: "border-emerald-200" },
  inaccurate: { icon: AlertTriangle, c: "text-amber-600",  bg: "bg-amber-50",   b: "border-amber-200" },
  missing:    { icon: XCircle,       c: "text-rose-600",   bg: "bg-rose-50",     b: "border-rose-200" },
  unknown:    { icon: HelpCircle,    c: "text-slate-500",  bg: "bg-slate-50",    b: "border-slate-200" },
};

/* ── Section header used inside accordion triggers ── */
export function SectionBadge({ count, color }) {
  return <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${color}`}>{count}</span>;
}
